import { createSelector } from 'reselect';
import getShop from '@core/reducers/shop/selectors/getShop';
import { ONLINE, OFFLINE } from './constants';

const getShopPaymentMethodsDivided = createSelector(
  getShop,
  shop => {
    const initValue = { [ONLINE]: [], [OFFLINE]: [] };
    return shop?.paymentMethods
      ? shop.paymentMethods.reduce((obj, method) => {
          const { online } = method;
          const key = online ? ONLINE : OFFLINE;

          obj[key].push(method);
          return obj;
        }, initValue)
      : initValue;
  },
);

export default getShopPaymentMethodsDivided;
